import { FormOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useFormikContext } from 'formik';
import { ConditionItemRender } from './ConditionRenderer';
import KnowledgeTypeRenderer from './KnowledgeTypeRenderer';
import styled from '@emotion/styled';
import { Store } from 'components/StoreScopes';
import { useGetStoreGroupName } from '../StoreGroup/share';

function LogisticsFormContent({
  type,
  allStores,
  onEdit,
}: {
  type: Knowledge.KnowledgeType;
  allStores: Store[];
  onEdit: (value: any) => void;
}) {
  const { t, getStoreGroupName } = useGetStoreGroupName();

  const { values, initialValues } = useFormikContext<{ kc: any[] }>();

  return (
    <div>
      {values.kc.map((value, index) => {
        const { storeGroup, knowledges, stores, storeMap } = value;
        if (!knowledges.length) {
          return null;
        }
        return (
          <Container>
            <header>
              <h4>{getStoreGroupName(storeGroup)}</h4>
              <Button
                type="text"
                icon={<FormOutlined />}
                onClick={() => onEdit(initialValues.kc[index])}
              >
                {t('marketing.编辑')}
              </Button>
            </header>
            <div>
              {knowledges.map((knowledge: any, knowledgeIndex: number) => {
                return (
                  <section key={knowledgeIndex}>
                    <div>
                      <ConditionItemRender
                        value={knowledge.condition}
                        stores={stores}
                        allStores={allStores}
                      />
                    </div>
                    <div>
                      <KnowledgeTypeRenderer
                        singleMode
                        fieldNamePrefix={`kc.${index}.knowledges.${knowledgeIndex}`}
                        type={type}
                        storeMap={storeMap}
                      />
                    </div>
                  </section>
                );
              })}
            </div>
          </Container>
        );
      })}
    </div>
  );
}

const Container = styled.div`
  margin-bottom: 16px;
  border: solid 1px var(--fett-border-strong);
  border-radius: 8px;
  overflow: hidden;
  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 16px;
    background: var(--fett-bg-app);
    > h4 {
      margin-bottom: 0;
    }
  }
  > div {
    padding: 16px;
    background: var(--fett-bg-panel);
    > section {
      display: flex;
      border: solid 1px var(--fett-border-default);
      & + section {
        margin-top: 16px;
      }
      > div {
        flex: 1 0 0;
        padding: 16px;
        &:first-of-type {
          border-right: solid 1px var(--fett-border-default);
        }
      }
    }
  }
`;

export default LogisticsFormContent;
